var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81221 3.34728L1.93026 13.1667C1.80899 13.3767 1.74483 13.6148 1.74415 13.8574C1.74347 14.0999 1.8063 14.3383 1.92639 14.549C2.04649 14.7597 2.21966 14.9353 2.42867 15.0583C2.63769 15.1813 2.87526 15.2474 3.11776 15.2501H14.8817C15.1242 15.2474 15.3617 15.1813 15.5707 15.0583C15.7798 14.9353 15.9529 14.7597 16.073 14.549C16.1931 14.3383 16.256 14.0999 16.2553 13.8574C16.2546 13.6148 16.1904 13.3767 16.0692 13.1667L10.1872 3.34728C10.0634 3.14319 9.8891 2.97445 9.68109 2.85734C9.47309 2.74023 9.23841 2.67871 8.99971 2.67871C8.761 2.67871 8.52633 2.74023 8.31832 2.85734C8.11032 2.97445 7.93601 3.14319 7.81221 3.34728V3.34728Z",
    stroke: "#EC9E2C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.9165V9.69428",
    stroke: "#EC9E2C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.4722H9.00694",
    stroke: "#EC9E2C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(0.666504 0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWarning);
export default __webpack_public_path__ + "static/media/notification-warning.e5d3a375f775b4f9727ae52959fd3420.svg";
export { ForwardRef as ReactComponent };